import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appInputAutoResize]',
  standalone: true
})
export class InputAutoResizeDirective implements AfterViewInit {
  private readonly maxRows = 5;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.adjust();
  }

  @HostListener('input')
  onInput(): void {
    this.adjust();
  }

  private adjust(): void {
    const textarea = this.el.nativeElement as HTMLTextAreaElement;

    // Reset height to recalculate
    this.renderer.setStyle(textarea, 'height', 'auto');

    const lineHeight = this.getLineHeight(textarea);
    const maxHeight = lineHeight * this.maxRows;

    const newHeight = Math.min(textarea.scrollHeight, maxHeight);
    this.renderer.setStyle(textarea, 'height', `${newHeight}px`);

    // Toggle scrollbar if needed
    this.renderer.setStyle(textarea, 'overflow-y', textarea.scrollHeight > maxHeight ? 'auto' : 'hidden');
  }

  private getLineHeight(textarea: HTMLTextAreaElement): number {
    const lineHeightStr = getComputedStyle(textarea).lineHeight;
    return parseFloat(lineHeightStr || '16'); // fallback value
  }
}
